var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5377 0.0712891L8.78251 3.58174H2.81474C1.45339 3.58174 0.357422 4.67771 0.357422 6.03906V21.4851C0.357422 22.8464 1.45339 23.9424 2.81474 23.9424H26.6858C28.0472 23.9424 29.1431 22.8464 29.1431 21.4851V6.03906C29.1431 4.67771 28.0472 3.58174 26.6858 3.58174H20.7181L18.9628 0.0712891H10.5377ZM14.7503 5.68801C19.1887 5.68801 22.8243 9.32368 22.8243 13.7621C22.8243 18.2004 19.1887 21.8361 14.7503 21.8361C10.3119 21.8361 6.67624 18.2004 6.67624 13.7621C6.67624 9.32364 10.3119 5.68801 14.7503 5.68801ZM14.7503 9.19847C12.2091 9.19847 10.1867 11.2209 10.1867 13.7621C10.1867 16.3032 12.2092 18.3256 14.7503 18.3256C17.2915 18.3256 19.3139 16.3032 19.3139 13.7621C19.3139 11.2209 17.2915 9.19847 14.7503 9.19847Z",
    fill: "#0A0422"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.5ce84b26802fefd078642040c57f39fd.svg";
export { ForwardRef as ReactComponent };